import BaseStore from 'customer-flows/stores/base-store'
import { context } from 'customer-flows/utils/core'

export default class ProgramRelatedFlowsStoreClass extends BaseStore {
  @context('program') program: ProgramStore['program']

  get relatedPrograms(): RelatedProgram[] {
    const program = this.program.value
    if (program && 'relatedPrograms' in program) {
      return program.relatedPrograms ?? []
    }
    return []
  }
}

declare global {
  export type ProgramRelatedFlowsStore = ProgramRelatedFlowsStoreClass
  export interface StoreRegistry {
    'program/related-flows': ProgramRelatedFlowsStore
  }
}
